export const translations = {
  es: {
    translation: {
      // Navigation
      nav: {
        home: "Inicio",
        about: "Quiénes Somos",
        services: "Servicios",
        portfolio: "Portafolio",
        talent: "Talento",
        venues: "Espacios",
        contact: "Contacto",
        faq: "FAQ",
        login: "Iniciar Sesión",
        register: "Registrarse",
        dashboard: "Panel",
        logout: "Cerrar Sesión"
      },
      // Hero
      hero: {
        tagline: "Donde el talento se convierte en experiencia",
        subtitle: "Agencia creativa y estratégica especializada en booking, management artístico, producción de eventos y experiencias musicales premium.",
        cta_services: "Explorar Servicios",
        cta_contact: "Contáctanos"
      },
      // About
      about: {
        title: "Quiénes Somos",
        subtitle: "Conectamos talento con marcas, espacios y audiencias",
        description: "GS AGENCY es una compañía creativa y estratégica especializada en booking, management, producción artística y experiencias musicales. Diseñamos proyectos rentables, memorables y escalables.",
        vision: "Visión",
        vision_text: "Ser la agencia de referencia en Latinoamérica para la creación de experiencias culturales y de entretenimiento premium.",
        mission: "Misión",
        mission_text: "Transformar talento en marcas sostenibles y crear experiencias que posicionen a nuestros clientes en el mercado global."
      },
      // Services
      services: {
        title: "Nuestros Servicios",
        subtitle: "Soluciones integrales para el entretenimiento",
        booking: {
          name: "Booking Artístico",
          description: "Representación y contratación de DJs, bandas y artistas nacionales e internacionales para eventos privados y corporativos."
        },
        management: {
          name: "Management Artístico",
          description: "Gestión integral de carrera artística: estrategia de marca personal, posicionamiento internacional y planificación de lanzamientos."
        },
        events: {
          name: "Producción de Eventos",
          description: "Diseño y ejecución de experiencias musicales: eventos boutique, festivales culturales, activaciones de marca."
        },
        audiovisual: {
          name: "Producción Audiovisual",
          description: "Grabación de shows en vivo, contenido para redes sociales, reels, aftermovies y material promocional."
        },
        branding: {
          name: "Branding & Marketing",
          description: "Desarrollo de identidad visual, diseño de flyers y campañas, estrategias de lanzamiento y gestión de colaboraciones."
        },
        experiences: {
          name: "Experiencias Exclusivas",
          description: "Eventos de aforo limitado, experiencias premium para marcas y creación de comunidades culturales."
        },
        view_all: "Ver Todos los Servicios"
      },
      // Portfolio
      portfolio: {
        title: "Nuestro Trabajo",
        subtitle: "Proyectos que transforman ideas en experiencias memorables",
        filter_all: "Todos",
        view_project: "Ver Proyecto",
        view_all: "Ver Portafolio Completo"
      },
      // Talent
      talent: {
        title: "Talento",
        subtitle: "Artistas de clase mundial listos para tu próximo evento",
        filter_all: "Todos",
        filter_dj: "DJs",
        filter_band: "Bandas",
        filter_artist: "Artistas",
        view_profile: "Ver Perfil",
        book_now: "Solicitar Booking",
        view_all: "Ver Todo el Talento"
      },
      // Venues
      venues: {
        title: "Espacios",
        subtitle: "Venues exclusivos para experiencias únicas",
        filter_all: "Todos",
        filter_club: "Clubs",
        filter_rooftop: "Rooftops",
        filter_beach: "Beach Clubs",
        filter_hotel: "Hoteles",
        capacity: "Capacidad",
        view_venue: "Ver Espacio",
        request_info: "Solicitar Información",
        view_all: "Ver Todos los Espacios"
      },
      // Testimonials
      testimonials: {
        title: "Lo Que Dicen de Nosotros",
        subtitle: "Experiencias que hablan por sí solas"
      },
      // Clients
      clients: {
        title: "Clientes & Aliados",
        subtitle: "Marcas que confían en nosotros"
      },
      // Contact
      contact: {
        title: "Contacto",
        subtitle: "Convierte tu visión en realidad",
        form: {
          name: "Nombre Completo",
          email: "Correo Electrónico",
          phone: "Teléfono",
          company: "Empresa / Marca",
          service: "Servicio de Interés",
          message: "Mensaje",
          submit: "Enviar Mensaje",
          success: "Mensaje enviado correctamente",
          error: "Error al enviar el mensaje"
        },
        info: {
          email: "info@gsagency.com",
          phone: "+52 5518 73 7664",
          location: "Ciudad de México, México"
        }
      },
      // FAQ
      faq: {
        title: "Preguntas Frecuentes",
        subtitle: "Todo lo que necesitas saber"
      },
      // Footer
      footer: {
        tagline: "Donde el talento se convierte en experiencia",
        services: "Servicios",
        company: "Compañía",
        legal: "Legal",
        privacy: "Privacidad",
        terms: "Términos",
        cookies: "Cookies",
        follow: "Síguenos",
        rights: "Todos los derechos reservados"
      },
      // Auth
      auth: {
        login: "Iniciar Sesión",
        register: "Registrarse",
        email: "Correo Electrónico",
        password: "Contraseña",
        confirm_password: "Confirmar Contraseña",
        name: "Nombre Completo",
        forgot_password: "¿Olvidaste tu contraseña?",
        no_account: "¿No tienes cuenta?",
        have_account: "¿Ya tienes cuenta?",
        google_login: "Continuar con Google",
        or: "o",
        role: "Tipo de Cuenta",
        roles: {
          artist: "Artista",
          model: "Modelo",
          venue_owner: "Dueño de Venue"
        }
      },
      // Dashboard
      dashboard: {
        welcome: "Bienvenido",
        overview: "Resumen",
        profile: "Mi Perfil",
        media: "Mis Archivos",
        settings: "Configuración",
        pending: "Pendiente de Aprobación",
        approved: "Aprobado",
        draft: "Borrador",
        submit_review: "Enviar a Revisión",
        save_draft: "Guardar Borrador"
      },
      // Admin
      admin: {
        dashboard: "Panel de Control",
        users: "Usuarios",
        artists: "Artistas",
        models: "Modelos",
        venues: "Venues",
        projects: "Proyectos",
        services: "Servicios",
        leads: "Leads",
        testimonials: "Testimonios",
        clients: "Clientes",
        faqs: "FAQs",
        settings: "Configuración",
        activity: "Actividad",
        pending_reviews: "Revisiones Pendientes",
        approve: "Aprobar",
        reject: "Rechazar",
        request_changes: "Solicitar Cambios"
      },
      // Common
      common: {
        loading: "Cargando...",
        error: "Error",
        success: "Éxito",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        edit: "Editar",
        view: "Ver",
        search: "Buscar",
        filter: "Filtrar",
        sort: "Ordenar",
        next: "Siguiente",
        previous: "Anterior",
        show_more: "Ver Más",
        show_less: "Ver Menos"
      },
      // CTA Section
      cta: {
        how_help: "¿Cómo podemos ayudarte?",
        start_project: "Empieza tu proyecto",
        request_booking: "Solicitar Booking",
        hire_talent: "Contrata talento para tu evento",
        produce_event: "Producir Evento",
        design_experience: "Diseñamos tu experiencia completa",
        submit_venue: "Presentar Venue",
        join_venues: "Únete a nuestra red de espacios",
        join_talent: "Unirse como Talento",
        join_roster: "Sé parte de nuestro roster"
      }
    }
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: "Home",
        about: "About Us",
        services: "Services",
        portfolio: "Portfolio",
        talent: "Talent",
        venues: "Venues",
        contact: "Contact",
        faq: "FAQ",
        login: "Login",
        register: "Register",
        dashboard: "Dashboard",
        logout: "Logout"
      },
      // Hero
      hero: {
        tagline: "Where talent becomes experience",
        subtitle: "Creative and strategic agency specialized in booking, artist management, event production and premium musical experiences.",
        cta_services: "Explore Services",
        cta_contact: "Contact Us"
      },
      // About
      about: {
        title: "About Us",
        subtitle: "We connect talent with brands, venues and audiences",
        description: "GS AGENCY is a creative and strategic company specialized in booking, management, artistic production and musical experiences. We design profitable, memorable and scalable projects.",
        vision: "Vision",
        vision_text: "To be the reference agency in Latin America for creating premium cultural and entertainment experiences.",
        mission: "Mission",
        mission_text: "Transform talent into sustainable brands and create experiences that position our clients in the global market."
      },
      // Services
      services: {
        title: "Our Services",
        subtitle: "Comprehensive entertainment solutions",
        booking: {
          name: "Artistic Booking",
          description: "Representation and hiring of DJs, bands and national/international artists for private and corporate events."
        },
        management: {
          name: "Artist Management",
          description: "Comprehensive career management: personal branding strategy, international positioning and release planning."
        },
        events: {
          name: "Event Production",
          description: "Design and execution of musical experiences: boutique events, cultural festivals, brand activations."
        },
        audiovisual: {
          name: "Audiovisual Production",
          description: "Live show recording, social media content, reels, aftermovies and promotional material."
        },
        branding: {
          name: "Branding & Marketing",
          description: "Visual identity development, flyer and campaign design, launch strategies and collaboration management."
        },
        experiences: {
          name: "Exclusive Experiences",
          description: "Limited capacity events, premium brand experiences and cultural community creation."
        },
        view_all: "View All Services"
      },
      // Portfolio
      portfolio: {
        title: "Our Work",
        subtitle: "Projects that transform ideas into memorable experiences",
        filter_all: "All",
        view_project: "View Project",
        view_all: "View Full Portfolio"
      },
      // Talent
      talent: {
        title: "Talent",
        subtitle: "World-class artists ready for your next event",
        filter_all: "All",
        filter_dj: "DJs",
        filter_band: "Bands",
        filter_artist: "Artists",
        view_profile: "View Profile",
        book_now: "Request Booking",
        view_all: "View All Talent"
      },
      // Venues
      venues: {
        title: "Venues",
        subtitle: "Exclusive spaces for unique experiences",
        filter_all: "All",
        filter_club: "Clubs",
        filter_rooftop: "Rooftops",
        filter_beach: "Beach Clubs",
        filter_hotel: "Hotels",
        capacity: "Capacity",
        view_venue: "View Venue",
        request_info: "Request Information",
        view_all: "View All Venues"
      },
      // Testimonials
      testimonials: {
        title: "What They Say About Us",
        subtitle: "Experiences that speak for themselves"
      },
      // Clients
      clients: {
        title: "Clients & Partners",
        subtitle: "Brands that trust us"
      },
      // Contact
      contact: {
        title: "Contact",
        subtitle: "Turn your vision into reality",
        form: {
          name: "Full Name",
          email: "Email",
          phone: "Phone",
          company: "Company / Brand",
          service: "Service of Interest",
          message: "Message",
          submit: "Send Message",
          success: "Message sent successfully",
          error: "Error sending message"
        },
        info: {
          email: "info@gsagency.com",
          phone: "+52 5518 73 7664",
          location: "Mexico City, Mexico"
        }
      },
      // FAQ
      faq: {
        title: "Frequently Asked Questions",
        subtitle: "Everything you need to know"
      },
      // Footer
      footer: {
        tagline: "Where talent becomes experience",
        services: "Services",
        company: "Company",
        legal: "Legal",
        privacy: "Privacy",
        terms: "Terms",
        cookies: "Cookies",
        follow: "Follow Us",
        rights: "All rights reserved"
      },
      // Auth
      auth: {
        login: "Login",
        register: "Register",
        email: "Email",
        password: "Password",
        confirm_password: "Confirm Password",
        name: "Full Name",
        forgot_password: "Forgot your password?",
        no_account: "Don't have an account?",
        have_account: "Already have an account?",
        google_login: "Continue with Google",
        or: "or",
        role: "Account Type",
        roles: {
          artist: "Artist",
          model: "Model",
          venue_owner: "Venue Owner"
        }
      },
      // Dashboard
      dashboard: {
        welcome: "Welcome",
        overview: "Overview",
        profile: "My Profile",
        media: "My Files",
        settings: "Settings",
        pending: "Pending Approval",
        approved: "Approved",
        draft: "Draft",
        submit_review: "Submit for Review",
        save_draft: "Save Draft"
      },
      // Admin
      admin: {
        dashboard: "Dashboard",
        users: "Users",
        artists: "Artists",
        models: "Models",
        venues: "Venues",
        projects: "Projects",
        services: "Services",
        leads: "Leads",
        testimonials: "Testimonials",
        clients: "Clients",
        faqs: "FAQs",
        settings: "Settings",
        activity: "Activity",
        pending_reviews: "Pending Reviews",
        approve: "Approve",
        reject: "Reject",
        request_changes: "Request Changes"
      },
      // Common
      common: {
        loading: "Loading...",
        error: "Error",
        success: "Success",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        view: "View",
        search: "Search",
        filter: "Filter",
        sort: "Sort",
        next: "Next",
        previous: "Previous",
        show_more: "Show More",
        show_less: "Show Less"
      },
      // CTA Section
      cta: {
        how_help: "How can we help you?",
        start_project: "Start your project",
        request_booking: "Request Booking",
        hire_talent: "Hire talent for your event",
        produce_event: "Produce Event",
        design_experience: "We design your complete experience",
        submit_venue: "Submit Venue",
        join_venues: "Join our venues network",
        join_talent: "Join as Talent",
        join_roster: "Be part of our roster"
      }
    }
  },
  pt: {
    translation: {
      // Navigation
      nav: {
        home: "Início",
        about: "Quem Somos",
        services: "Serviços",
        portfolio: "Portfólio",
        talent: "Talento",
        venues: "Espaços",
        contact: "Contato",
        faq: "FAQ",
        login: "Entrar",
        register: "Cadastrar",
        dashboard: "Painel",
        logout: "Sair"
      },
      // Hero
      hero: {
        tagline: "Onde o talento se torna experiência",
        subtitle: "Agência criativa e estratégica especializada em booking, gestão artística, produção de eventos e experiências musicais premium.",
        cta_services: "Explorar Serviços",
        cta_contact: "Fale Conosco"
      },
      // About
      about: {
        title: "Quem Somos",
        subtitle: "Conectamos talento com marcas, espaços e públicos",
        description: "GS AGENCY é uma empresa criativa e estratégica especializada em booking, gestão, produção artística e experiências musicais. Projetamos projetos rentáveis, memoráveis e escaláveis.",
        vision: "Visão",
        vision_text: "Ser a agência de referência na América Latina para a criação de experiências culturais e de entretenimento premium.",
        mission: "Missão",
        mission_text: "Transformar talento em marcas sustentáveis e criar experiências que posicionem nossos clientes no mercado global."
      },
      // Services
      services: {
        title: "Nossos Serviços",
        subtitle: "Soluções completas para entretenimento",
        booking: {
          name: "Booking Artístico",
          description: "Representação e contratação de DJs, bandas e artistas nacionais e internacionais para eventos privados e corporativos."
        },
        management: {
          name: "Gestão Artística",
          description: "Gestão integral de carreira artística: estratégia de marca pessoal, posicionamento internacional e planejamento de lançamentos."
        },
        events: {
          name: "Produção de Eventos",
          description: "Design e execução de experiências musicais: eventos boutique, festivais culturais, ativações de marca."
        },
        audiovisual: {
          name: "Produção Audiovisual",
          description: "Gravação de shows ao vivo, conteúdo para redes sociais, reels, aftermovies e material promocional."
        },
        branding: {
          name: "Branding & Marketing",
          description: "Desenvolvimento de identidade visual, design de flyers e campanhas, estratégias de lançamento e gestão de colaborações."
        },
        experiences: {
          name: "Experiências Exclusivas",
          description: "Eventos de capacidade limitada, experiências premium para marcas e criação de comunidades culturais."
        },
        view_all: "Ver Todos os Serviços"
      },
      // Portfolio
      portfolio: {
        title: "Nosso Trabalho",
        subtitle: "Projetos que transformam ideias em experiências memoráveis",
        filter_all: "Todos",
        view_project: "Ver Projeto",
        view_all: "Ver Portfólio Completo"
      },
      // Talent
      talent: {
        title: "Talento",
        subtitle: "Artistas de classe mundial prontos para seu próximo evento",
        filter_all: "Todos",
        filter_dj: "DJs",
        filter_band: "Bandas",
        filter_artist: "Artistas",
        view_profile: "Ver Perfil",
        book_now: "Solicitar Booking",
        view_all: "Ver Todo o Talento"
      },
      // Venues
      venues: {
        title: "Espaços",
        subtitle: "Venues exclusivos para experiências únicas",
        filter_all: "Todos",
        filter_club: "Clubs",
        filter_rooftop: "Rooftops",
        filter_beach: "Beach Clubs",
        filter_hotel: "Hotéis",
        capacity: "Capacidade",
        view_venue: "Ver Espaço",
        request_info: "Solicitar Informação",
        view_all: "Ver Todos os Espaços"
      },
      // Testimonials
      testimonials: {
        title: "O Que Dizem de Nós",
        subtitle: "Experiências que falam por si mesmas"
      },
      // Clients
      clients: {
        title: "Clientes & Parceiros",
        subtitle: "Marcas que confiam em nós"
      },
      // Contact
      contact: {
        title: "Contato",
        subtitle: "Transforme sua visão em realidade",
        form: {
          name: "Nome Completo",
          email: "E-mail",
          phone: "Telefone",
          company: "Empresa / Marca",
          service: "Serviço de Interesse",
          message: "Mensagem",
          submit: "Enviar Mensagem",
          success: "Mensagem enviada com sucesso",
          error: "Erro ao enviar mensagem"
        },
        info: {
          email: "info@gsagency.com",
          phone: "+52 5518 73 7664",
          location: "Cidade do México, México"
        }
      },
      // FAQ
      faq: {
        title: "Perguntas Frequentes",
        subtitle: "Tudo o que você precisa saber"
      },
      // Footer
      footer: {
        tagline: "Onde o talento se torna experiência",
        services: "Serviços",
        company: "Empresa",
        legal: "Legal",
        privacy: "Privacidade",
        terms: "Termos",
        cookies: "Cookies",
        follow: "Siga-nos",
        rights: "Todos os direitos reservados"
      },
      // Auth
      auth: {
        login: "Entrar",
        register: "Cadastrar",
        email: "E-mail",
        password: "Senha",
        confirm_password: "Confirmar Senha",
        name: "Nome Completo",
        forgot_password: "Esqueceu sua senha?",
        no_account: "Não tem conta?",
        have_account: "Já tem conta?",
        google_login: "Continuar com Google",
        or: "ou",
        role: "Tipo de Conta",
        roles: {
          artist: "Artista",
          model: "Modelo",
          venue_owner: "Proprietário de Venue"
        }
      },
      // Dashboard
      dashboard: {
        welcome: "Bem-vindo",
        overview: "Resumo",
        profile: "Meu Perfil",
        media: "Meus Arquivos",
        settings: "Configurações",
        pending: "Aguardando Aprovação",
        approved: "Aprovado",
        draft: "Rascunho",
        submit_review: "Enviar para Revisão",
        save_draft: "Salvar Rascunho"
      },
      // Admin
      admin: {
        dashboard: "Painel de Controle",
        users: "Usuários",
        artists: "Artistas",
        models: "Modelos",
        venues: "Venues",
        projects: "Projetos",
        services: "Serviços",
        leads: "Leads",
        testimonials: "Depoimentos",
        clients: "Clientes",
        faqs: "FAQs",
        settings: "Configurações",
        activity: "Atividade",
        pending_reviews: "Revisões Pendentes",
        approve: "Aprovar",
        reject: "Rejeitar",
        request_changes: "Solicitar Alterações"
      },
      // Common
      common: {
        loading: "Carregando...",
        error: "Erro",
        success: "Sucesso",
        save: "Salvar",
        cancel: "Cancelar",
        delete: "Excluir",
        edit: "Editar",
        view: "Ver",
        search: "Buscar",
        filter: "Filtrar",
        sort: "Ordenar",
        next: "Próximo",
        previous: "Anterior",
        show_more: "Ver Mais",
        show_less: "Ver Menos"
      },
      // CTA Section
      cta: {
        how_help: "Como podemos ajudar?",
        start_project: "Comece seu projeto",
        request_booking: "Solicitar Booking",
        hire_talent: "Contrate talento para seu evento",
        produce_event: "Produzir Evento",
        design_experience: "Projetamos sua experiência completa",
        submit_venue: "Apresentar Venue",
        join_venues: "Junte-se à nossa rede de espaços",
        join_talent: "Juntar-se como Talento",
        join_roster: "Faça parte do nosso roster"
      }
    }
  }
};
